<template>
  <v-container>
    <v-row>
      <v-col class="pa-1 pt-1 pb-0" cols="12" md="6">
        <FormField
          v-model="store.formData.codigoPostal"
          label="Codigo Postal"
          :rules="[rules.requiredCP, rules.requiredCPLength, rules.requiredCPNumbers]"
        />
      </v-col>
      <v-col class="pa-1 pt-1 pb-0" cols="12" md="6">
        <FormField
          v-model="store.formData.nombreVialidad"
          label="Nombre de Vialidad"
          :rules="[rules.required]"
        />
      </v-col>
      <v-col class="pa-1 pt-1 pb-0" cols="12" md="6">
        <FormField
          v-model="store.formData.tipoVialidad"
          label="Tipo de Vialidad"
          :rules="[rules.required]"
        />
      </v-col>
      <v-col class="pa-1 pt-1 pb-0" cols="12" md="6">
        <FormField
          v-model="store.formData.numeroExterior"
          label="Número Exterior"
          :rules="[rules.required]"
        />
      </v-col>
      <v-col class="pa-1 pt-1 pb-0" cols="12" md="6">
        <FormField
          v-model="store.formData.numeroInterior"
        >
          <template v-slot:label>
            Número Interior<small class="text-caption"> - Opcional</small>
          </template>
        </FormField>
      </v-col>
      <v-col class="pa-1 pt-1 pb-0" cols="12" md="6">
        <FormField
          v-model="store.formData.colonia"
          label="Colonia"
          :rules="[rules.required]"
        />
      </v-col>
      <v-col class="pa-1 pt-1 pb-0" cols="12" md="6">
        <FormField
          v-model="store.formData.alcaldiaMunicipio"
          label="Alcaldía o Municipio"
          :rules="[rules.required]"
        />
      </v-col>
      <v-col class="pa-1 pt-1 pb-0" cols="12" md="6">
        <FormField
          v-model="store.formData.entidad"
          label="Entidad"
          :rules="[rules.required]"
        />
      </v-col>
      <v-col class="pa-1 pt-1 pb-0" cols="12" md="6">
        <FormField
          v-model="store.formData.entreCalle1"
          label="Entre Calle"
        />
      </v-col>
      <v-col class="pa-1 pt-1 pb-0" cols="12" md="6">
        <FormField
          v-model="store.formData.entreCalle2"
          label="Y Calle"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { useSolicitudMensajeriaStore } from '@/stores/solicitudMensajeria'
import FormField from './FormField.vue'

const store = useSolicitudMensajeriaStore()

const rules = {
  requiredCP: (value) => !!value || "Codigo Postal requerido",
  requiredCPLength: (value) => value?.toString().length == 5 || "Codigo Postal invalido",
  requiredCPNumbers: (value) => /^[0-9]{5}$/.test(value) || "Solo se aceptan números",
  required: (value) => !!value || "Campo requerido"
}
</script> 